// extracted by mini-css-extract-plugin
export var avatar = "_od-3";
export var avatarContainer = "_od-2";
export var avatarSpacer = "_od-5";
export var avatarSpacerContainer = "_od-4";
export var avatarStackContainer = "_od-1";
export var bubble = "_od-0";
export var remainderBubble = "_od-6";